import React, {useCallback} from 'react';
import {any, func} from 'prop-types';
import RcCheckbox from 'rc-checkbox';
import If from '../../misc/If';

import './Checkbox.css';

const propTypes = {
  description : any,
  label       : any,
  onChange    : func,
  value       : any
};

const defaultProps = {
  description : null,
  label       : null,
  onChange    : () => null,
  value       : false
};

function Checkbox(props) {
  const {description, label, onChange, value} = props;

  const handleOnChange = useCallback(event => {
    const {target : {checked}} = event;

    onChange(checked);
  }, [onChange])

  return (
    <div className="checkbox__wrapper">
      <If condition={Boolean(label)}>
        <label className="checkbox__label">
          {label}
        </label>
      </If>

      <label className="checkbox__wrap">
        <RcCheckbox
          checked={Boolean(value)}
          prefixCls="checkbox"
          className=""
          onChange={handleOnChange}
        />

        <span className="checkbox__text">
          {description}
        </span>
      </label>
      <p className="checkbox__message_hidden">
          message
      </p>
    </div>
  )
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
